import { useState, useCallback } from 'react';

// Wraps a mutating julkisivu v2 API call so every table update (Poränäyte,
// Peitepaksuus, rakenneosa, testi-type blocks) shows the same standard
// success message with an info toggle to inspect the raw response — instead
// of succeeding silently, which made it hard to tell whether a click
// actually did anything (see: the rakenneosa-dedup confusion this session).
// Errors are captured the same way, so the info button doubles as an easy
// way to see exactly what the backend rejected and why.
const SUCCESS_MESSAGE = 'Julkisivu-projektin päivitys onnistui';

export default function useApiFeedback() {
  const [feedback, setFeedback] = useState(null); // { ok, message, response }

  const run = useCallback(async (fn, successMessage = SUCCESS_MESSAGE) => {
    try {
      const res = await fn();
      setFeedback({ ok: true, message: successMessage, response: res?.data ?? null });
      return res;
    } catch (e) {
      setFeedback({ ok: false, message: e?.response?.data?.error || e.message, response: e?.response?.data ?? null });
      throw e;
    }
  }, []);

  const clearFeedback = useCallback(() => setFeedback(null), []);

  return { feedback, run, clearFeedback };
}
